import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Switch, Space, InputNumber, Alert, Select, TimePicker, Row, Col, Upload } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { createTruck, getTruckById, getTrucksList, updateTruck } from '../../store/slices/truckSlice';
import { CheckCircleOutlined, CloseCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { getUserById, updateUser, updateUserTruck } from '../../store/slices/userSlice';
import dayjs from "dayjs";
import DayAndTime from '../../components/DayAndTime';

const EditAgent = () => {
    const { id } = useParams();
    const [form] = Form.useForm();
    const [truckAssignedForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [truckAssignedLoading, setTruckAssignedLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [fileList, setFileList] = useState([]);
    const [type, setType] = useState("agent");
    const { userData } = useSelector((state) => state?.user)
    const { trucksList } = useSelector((state) => state?.truck)
    console.log(userData)
    useEffect(() => {
        dispatch(getUserById(id))
        dispatch(getTrucksList())
    }, [dispatch, id])
    useEffect(() => {
        if (userData?.data?.user) {
            let isVerified = null
            if (userData?.data?.user?.is_verified == 0) {
                isVerified = "Block"
            } else if (userData?.data?.user?.is_verified == 1) {
                isVerified = "UnBlock"
            }
            const defaultImage = userData?.data?.user?.profile_image
                ? [
                    {
                        uid: '-1',
                        name: userData.data.user.profile_image.split('/').pop(),
                        status: 'done',
                        url: userData.data.user.profile_image
                    }
                ]
                : [];

            setFileList(defaultImage);

            form.setFieldsValue({
                first_name : userData?.data?.user?.first_name,
                last_name : userData?.data?.user?.last_name,
                phone : userData?.data?.user?.phone,
                is_verified : isVerified,
                // image : userData?.data?.user?.profile_image
                image: defaultImage
            })
            const formatted = userData?.data?.agentAvailability?.availability?.map(item => ({
                ...item,
                start_time: item.start_time ? dayjs(item.start_time, "HH:mm") : null,
                end_time: item.end_time ? dayjs(item.end_time, "HH:mm") : null
            }));
            form.setFieldsValue({ availability: formatted });

            const workingHoursFormatted = userData?.data?.workingHours?.working_hours?.map(item => ({
                ...item,
                start_time: item.start_time ? dayjs(item.start_time, "HH:mm") : null,
                end_time: item.end_time ? dayjs(item.end_time, "HH:mm") : null
            }));
            form.setFieldsValue({ working_hours: workingHoursFormatted });
        }
    }, [form, userData])
    useEffect(() => {
        if (userData?.data?.userTruck) {
            truckAssignedForm.setFieldsValue({ 
                truck_id : userData?.data?.userTruck?.truck_id
            })
        }
    }, [userData, truckAssignedForm])
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        console.log(values)
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            let isVerified = null
            if (values?.is_verified == "Block") {
                isVerified = 0
            } else if (values?.is_verified == "UnBlock") {
                isVerified = 1
            } else {
                isVerified = userData?.data?.user?.is_verified
            }

            // const formatted = values.availability.map(item => ({
            //     day: item.day,
            //     start_time: item.start_time.format("HH:mm"),
            //     end_time: item.end_time.format("HH:mm")
            // }));

            // const formattedWorkingHours = values.working_hours.map(item => ({
            //     day: item.day,
            //     start_time: item.start_time.format("HH:mm"),
            //     end_time: item.end_time.format("HH:mm")
            // }));

            const formData = new FormData();

            formData.append('id', id);
            formData.append('first_name', values?.first_name);
            formData.append('last_name', values?.last_name);
            formData.append('phone', values?.phone);
            formData.append('is_verified', isVerified);
            if (values?.image && values?.image?.file) {
                formData.append('image', values?.image?.file);
            }

            const resultAction = await dispatch(updateUser(formData));
            setType('agent')

            if (updateUser.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Agent updated successfully!');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error updating agent');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error updating agent.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const onTruckAssignedSubmit = async (values) => {
        setTruckAssignedLoading(true)
        setAlertMessage('')
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(updateUserTruck({
                user_id : id,
                truck_id : values?.truck_id,
            }));
            setType('user_truck')

            if (updateUserTruck.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'User Truck updated successfully!');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.message || 'Error updating user truck');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error updating user truck.');
            setAlertType('error');
            console.log(error)
        } finally {
            setTruckAssignedLoading(false);
        }
    }

    const handleChange = (info) => {
        setFileList(info.fileList.slice(-1));
        // setFileList(info.file);
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            setAlertMessage('You can only upload image files!');
            setAlertType('error');
            return Upload.LIST_IGNORE;
        }
        return false; // prevent auto upload
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Agent</h1>
            <Card title="Edit Agent" style={{ marginBottom: 16 }}>
                {alertMessage && type == "agent" && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    // handleValuesChange={handleFormValuesChange}
                    form={form}
                    // initialValues={{
                    //     // siteName: 'Furnifix Admin',
                    //     // emailNotifications: true,
                    // }}
                >
                    <Form.Item
                        label="First Name"
                        name="first_name"
                        rules={[{ required: true, message: 'Please input first name!' }]}
                    >
                        <Input placeholder="Enter first name" />
                    </Form.Item>
                    <Form.Item
                        label="Last Name"
                        name="last_name"
                        rules={[{ required: true, message: 'Please input last name!' }]}
                    >
                        <Input placeholder="Enter last name" />
                    </Form.Item>
                    <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[{ required: true, message: 'Please input phone!' }]}
                    >
                        <InputNumber placeholder="Enter phone" style={{ width : "100%" }} />
                    </Form.Item>
                    <Form.Item
                        label="Block/Unblock"
                        name="is_verified"
                    >
                        <Select
                            options={[
                                { value: 'Block', label: 'Block' },
                                { value: 'UnBlock', label: 'UnBlock' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item label="Profile Image" name="image"  rules={[{ required: true, message: 'Please upload atleast one image' }]}>
                        <Upload
                        beforeUpload={beforeUpload}
                        fileList={fileList}
                        maxCount={1}
                        onChange={handleChange}
                        accept="image/*"
                        listType="picture"
                        >
                        <Button icon={<UploadOutlined />}>Select Images</Button>
                        </Upload>
                    </Form.Item>
                    {/* <DayAndTime text="Availability" name="availability" btnText="Add Another Availability" /> */}
                    {/* <DayAndTime text="Working Hour" name="working_hours" btnText="Add Another Working Hour" /> */}
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>

            <Card title="Truck Assigned To Agent" style={{ marginBottom: 16 }}>
                {alertMessage && type == "user_truck" && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onTruckAssignedSubmit}
                    form={truckAssignedForm}
                >
                    <Form.Item
                        label="Trucks"
                        name="truck_id"
                        rules={[{ required: true, message: 'Please select a truck!' }]}
                        >
                        <Select
                            style={{ width: "100%" }}
                            name="truck_list"
                            options={
                                trucksList?.data?.map((truck) => ({
                                    label: truck.truck_num,
                                    value: truck._id,
                                })) || []
                            }
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={truckAssignedLoading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default EditAgent;